/**
 * Created by Daniela on 26/09/2016.
 */
import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { MedidasRoutingModule } from "./medidas.routing";
import { MedidaService } from "./shared/medida.service";
import { MedidaApiService } from "./shared/medida-api.service";
import { MedidaNavigationService } from "./shared/medida-navigation.service";
import { MedidasComponent } from "./medidas.component";
import { MedidaListComponent } from "./medida-list/medida-list.component";
import { MedidaFormComponent } from "./medida-form/medida-form.component";

@NgModule({
  imports: [
    SharedModule,
    MedidasRoutingModule
  ],
  providers: [
    MedidaService,
    MedidaApiService,
    MedidaNavigationService
  ],
  declarations: [
    MedidasComponent,
    MedidaFormComponent,
    MedidaListComponent
  ]
})
export class MedidasModule {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/medidas/medidas.module.ts
 **/